import React from 'react';
import { PATHS } from './paths';
import { string } from 'prop-types';

const Icon = ({ classNames, name, size, color }) => {
  let width = '16';
  let height = '16';

  switch (name) {
    case 'partner':
      width = '15';
      break;
    case 'spinner':
      width = '19';
      height = '19';
      break;
    default:
      break;
  }

  return (
    <svg
      className={`${classNames} beta-icon ${color} ${size}`}
      width="16"
      height="16"
      viewBox={`0 0 ${width} ${height}`}
    >
      {PATHS.map((path, index) => {
        if (path.name === name) {
          if (typeof path.path === 'object') {
            return Object.keys(path.path).map((subKey, subIndex) => {
              const subPath = path.path[subKey];
              return (
                <path
                  key={subIndex}
                  d={subPath['path']}
                  fill={'fill' in subPath ? subPath['fill'] : ''}
                />
              );
            });
          } else {
            return <path key={index} d={path.path} />;
          }
        }
        return null;
      })}
    </svg>
  );
};

export const IconColors = {
  regular: 'beta-icon--regular',
  ghost: 'beta-icon--ghost',
  error: 'beta-icon--error',
  primary: 'beta-icon--primary',
  muted: 'beta-icon--muted',
};

export const IconSizes = {
  144: 'beta-icon--144',
  136: 'beta-icon--136',
  128: 'beta-icon--128',
  120: 'beta-icon--120',
  112: 'beta-icon--112',
  104: 'beta-icon--104',
  96: 'beta-icon--96',
  92: 'beta-icon--92',
  88: 'beta-icon--88',
  84: 'beta-icon--84',
  80: 'beta-icon--80',
  76: 'beta-icon--76',
  72: 'beta-icon--72',
  68: 'beta-icon--68',
  64: 'beta-icon--64',
  60: 'beta-icon--60',
  56: 'beta-icon--56',
  52: 'beta-icon--52',
  48: 'beta-icon--48',
  44: 'beta-icon--44',
  40: 'beta-icon--40',
  36: 'beta-icon--36',
  32: 'beta-icon--32',
  28: 'beta-icon--28',
  24: 'beta-icon--24',
  20: 'beta-icon--20',
  19: 'beta-icon--19',
  16: 'beta-icon--16',
  12: 'beta-icon--12',
  8: 'beta-icon--8',
  6: 'beta-icon--6',
};

Icon.propTypes = {
  name: string,
  color: string,
  size: string,
  classNames: string,
};

Icon.defaultProps = {
  color: IconColors.regular,
  size: IconSizes[16],
  classNames: '',
};

export default Icon;
